"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, type JSX } from "react";
import { CreateProxyAction, PROFILE_PROXY_ACTION_LABELS } from "@/entities/IProxy";
import { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
import ProxyCreateActionConfigAllocateCic from "./ProxyCreateActionConfigAllocateCic";
import ProxyCreateActionConfigAllocateRep from "./ProxyCreateActionConfigAllocateRep";
import ProxyCreateActionConfigCreateDropToWave from "./ProxyCreateActionConfigCreateDropToWave";
import ProxyCreateActionConfigCreateWave from "./ProxyCreateActionConfigCreateWave";
import ProxyCreateActionConfigRateWaveDrop from "./ProxyCreateActionConfigRateWaveDrop";
import ProxyCreateActionConfigReadWave from "./ProxyCreateActionConfigReadWave";
import CommonTimeSelect from "@/components/utils/time/CommonTimeSelect";
import ProxyCreateActionConfigEndTimeSwitch from "./ProxyCreateActionConfigEndTimeSwitch";
export default function ProxyCreateActionConfig(t0) {
  const $ = _c(52);
  const {
    selectedActionType,
    submitting,
    onSubmit,
    onCancel
  } = t0;
  const [isEndTimeDisabled, setIsEndTimeDisabled] = useState(true);
  const [endTime, setEndTime] = useState(null);
  let t1;
  if ($[0] !== isEndTimeDisabled || $[1] !== onSubmit) {
    t1 = async action => {
      if (isEndTimeDisabled) {
        onSubmit({
          ...action,
          end_time: null
        });
        return;
      }
      onSubmit(action);
    };
    $[0] = isEndTimeDisabled;
    $[1] = onSubmit;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const submit = t1;
  let t2;
  if ($[3] !== endTime || $[4] !== onCancel || $[5] !== submit || $[6] !== submitting) {
    t2 = <ProxyCreateActionConfigAllocateRep endTime={endTime} submitting={submitting} onSubmit={submit} onCancel={onCancel} />;
    $[3] = endTime;
    $[4] = onCancel;
    $[5] = submit;
    $[6] = submitting;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== endTime || $[9] !== onCancel || $[10] !== submit || $[11] !== submitting) {
    t3 = <ProxyCreateActionConfigAllocateCic endTime={endTime} submitting={submitting} onSubmit={submit} onCancel={onCancel} />;
    $[8] = endTime;
    $[9] = onCancel;
    $[10] = submit;
    $[11] = submitting;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== endTime || $[14] !== onCancel || $[15] !== submit) {
    t4 = <ProxyCreateActionConfigCreateWave endTime={endTime} onSubmit={submit} onCancel={onCancel} />;
    $[13] = endTime;
    $[14] = onCancel;
    $[15] = submit;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== endTime || $[18] !== onCancel || $[19] !== submit) {
    t5 = <ProxyCreateActionConfigReadWave endTime={endTime} onSubmit={submit} onCancel={onCancel} />;
    $[17] = endTime;
    $[18] = onCancel;
    $[19] = submit;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== endTime || $[22] !== onCancel || $[23] !== submit) {
    t6 = <ProxyCreateActionConfigCreateDropToWave endTime={endTime} onSubmit={submit} onCancel={onCancel} />;
    $[21] = endTime;
    $[22] = onCancel;
    $[23] = submit;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== endTime || $[26] !== onCancel || $[27] !== submit) {
    t7 = <ProxyCreateActionConfigRateWaveDrop endTime={endTime} onSubmit={submit} onCancel={onCancel} />;
    $[25] = endTime;
    $[26] = onCancel;
    $[27] = submit;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== t2 || $[30] !== t3 || $[31] !== t4 || $[32] !== t5 || $[33] !== t6 || $[34] !== t7) {
    t8 = {
      [ApiProfileProxyActionType.AllocateRep]: t2,
      [ApiProfileProxyActionType.AllocateCic]: t3,
      [ApiProfileProxyActionType.CreateWave]: t4,
      [ApiProfileProxyActionType.ReadWave]: t5,
      [ApiProfileProxyActionType.CreateDropToWave]: t6,
      [ApiProfileProxyActionType.RateWaveDrop]: t7
    };
    $[29] = t2;
    $[30] = t3;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  const components = t8;
  const t9 = PROFILE_PROXY_ACTION_LABELS[selectedActionType];
  let t10;
  if ($[36] !== t9) {
    t10 = <p className="tw-mb-0 tw-text-lg tw-text-iron-50 tw-font-semibold">{t9}</p>;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== isEndTimeDisabled) {
    t11 = <ProxyCreateActionConfigEndTimeSwitch isActive={isEndTimeDisabled} setIsActive={setIsEndTimeDisabled} />;
    $[38] = isEndTimeDisabled;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  let t12;
  if ($[40] !== endTime || $[41] !== isEndTimeDisabled) {
    t12 = !isEndTimeDisabled && <div className="tw-w-full md:tw-w-auto"><span className={`${isEndTimeDisabled ? "tw-opacity-50" : ""} tw-block tw-text-sm tw-font-medium tw-leading-5 tw-text-iron-300`}>End time</span><div className="tw-mt-1.5"><CommonTimeSelect currentTime={endTime} onMillis={setEndTime} disabled={isEndTimeDisabled} /></div></div>;
    $[40] = endTime;
    $[41] = isEndTimeDisabled;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  const t13 = components[selectedActionType];
  let t14;
  if ($[43] !== t13) {
    t14 = <div className="tw-w-full md:tw-w-auto">{t13}</div>;
    $[43] = t13;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== t12 || $[46] !== t14) {
    t15 = <div className="tw-mt-4 tw-flex tw-flex-col md:tw-flex-row tw-gap-x-6 tw-gap-y-5">{t12}{t14}</div>;
    $[45] = t12;
    $[46] = t14;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] !== t10 || $[49] !== t11 || $[50] !== t15) {
    t16 = <div className="tw-p-5 tw-flex tw-flex-col tw-bg-iron-900 tw-rounded-lg tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-shadow-sm">{t10}{t11}{t15}</div>;
    $[48] = t10;
    $[49] = t11;
    $[50] = t15;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  return t16;
}